<template>
  <!-- leftBlock (左测导航栏组件)-->
  <el-container style="height: 100%;">
    <div style="width: 100%">
      <div class="mentten">
        <el-main class="main-map" style="height: 100%; padding: 0">
          <div
            ref="maps"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(3,28,74, 0.6)"
            id="map_canvas"
            style="height: 100%; position: relative"
          >
            <div id="container" tabindex="0" style="height: 100%"></div>
          </div>
          <div class="search-map">
            <ul
              style="
                width: 100%;
                height: 11%;
                background-color: #031d4d;
                opacity: 0.8;
              "
              class="flex k_b1"
            >
              <i class="k_top_left"></i>
              <i class="k_top_right"></i>
              <i class="k_bottom_left"></i>
              <i class="k_bottom_rigth"></i>
              <li @click="enterNum(1)">
                <img src="~@/img/map/toilet_vacuum.png" title="智慧厕所" />
              </li>
              <li @click="enterNum(2)">
                <img src="~@/img/map/toilet_general.png" title="智慧真空厕所" />
              </li>
              <li @click="enterNum(3)">
                <img src="~@/img/map/toilet_tradition.png" title="传统厕所" />
              </li>
            </ul>
            <div
              v-if="!searchShow"
              style="
                width: 100%;
                height: 30px;
                font-size: 20px;
                color: #fff;
                margin-top: 8px;
              "
              class="flex"
            >
              <span>智慧</span><span>真空</span><span>传统</span>
            </div>
            <ul class="search-text progressBar" v-if="searchShow">
              <span style="margin-bottom: 10px; color: yellow">{{
                titles
              }}</span>
              <li
                class="listOne"
                @click="searchOne($event)"
                v-for="(item, index) in toiletLists"
                :key="index"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <el-dialog
            :title="name"
            :visible.sync="centerDialogVisible"
            width="30%"
            :modal="false"
            center
          >
            <div class="textstyle">
              <span
                >开放时间：{{ $store.state.tolietyw.openTime || "暂无" }} 至
                {{ $store.state.tolietyw.closeTime || "暂无" }}</span
              >
            </div>
            <div class="textstyle">
              <span style="margin-right: 20px"
                >值班人员：{{ $store.state.tolietyw.principal || "暂无" }}</span
              >
              <span>联系电话：{{ $store.state.tolietyw.phone || "暂无" }}</span>
            </div>
            <span class="textstyle">查询时间：</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="center"
              value-format="yyyy-MM-dd"
              :default-time="defaultTime"
              @change="timeChange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <div style="width: 100%; height: 55vh; text-align: left">
              <div style="height: 30%">
                <div class="graphical_button">能耗</div>
                <echarts-line
                  :toilet="energy"
                  style="height: calc(100% - 40px)"
                ></echarts-line>
              </div>
              <div style="height: 30%; margin-top: 5%">
                <div class="graphical_button">人流量</div>
                <echarts-line
                  :toilet="visitors"
                  style="height: calc(100% - 40px)"
                ></echarts-line>
              </div>
              <div style="height: 30%; margin-top: 5%">
                <div class="graphical_button">用水量</div>
                <echarts-line
                  :toilet="water"
                  style="height: calc(100% - 40px)"
                ></echarts-line>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            title="告警信息"
            :visible.sync="AlarmdialogVisible"
            width="30%"
          >
            <div class="flexcz">
              <span style="font-size: 18px; margin-bottom: 15px"
                >{{ alarmdatas.name }}: 已触发告警按钮！</span
              >
              <span style="font-size: 18px"
                >运维人员：{{ alarmdatas.manager || "暂无" }} 联系电话：{{
                  alarmdatas.phone || "暂无"
                }}</span
              >
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="AlarmdialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="ChangeAlarm">确 定</el-button>
            </span>
          </el-dialog>
        </el-main>
      </div>
    </div>
  </el-container>
</template>

<script>
import $ from "jquery";
import echartsLine from "@/components/html/echartsLine.vue";
import global from "../../global";

export default {
  components: {
    echartsLine
  },
  data() {
    return {
      mapObj: null, //存放初始化的地图对象
      mass: null, //存放初始化的地图海量点对象
      markerMove: null, //鼠标经过点
      markerAlarm: null, //告警点
      notChange: false,
      giveAnAlarm: false,
      toiletLists: null,
      toiletListData: null,
      titles: null,
      searchShow: false,
      loading: false,
      timerA: null,
      socket: null,
      alarmList: [],
      alarmdatas: { name: null, phone: null, manager: null },
      alarmData: [{ name: null }],
      params: {
        // townId: 841,
        beginTime: new Date(),
        endTime: new Date()
      },

      water: [],
      energy: [],
      visitors: [],
      centerDialogVisible: false,
      AlarmdialogVisible: false,

      name: null, // 点位名称

      // 时间范围
      dateRange: [
        this.parseTime(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          "{y}-{m}-{d}"
        ),
        this.parseTime(new Date(), "{y}-{m}-{d}")
      ],
      defaultTime: ["00:00:00", "23:59:59"],
      pickerOptions: {
        shortcuts: [
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      legend: {
        img1: require("../../img/map/toilet_vacuum.png"),
        img2: require("../../img/map/toilet_general.png"),
        img3: require("../../img/map/toilet_move.png"),
        img4: require("../../img/map/alarm.gif"),
        img5: require("../../img/map/toilet_tradition.png")
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    initAMap() {
      //初始化高德地图

      const position = new AMap.LngLat(120.397428, 30.90923);
      this.mapObj = new AMap.Map("container", {
        resizeEnable: true,
        center: position,
        zoom: 11
      });
      this.mapObj.setMapStyle("amap://styles/blue");
      this.getToiletInfo();
    },
    timeChange() {
      this.getEnergyList(1);
      this.getEnergyList(2);
      this.getEnergyList(3);
    },
    getEnergyList(type) {
      this.params.type = type;
      let data = {
        id:
          type === 1
            ? "water"
            : type === 2
            ? "energy"
            : type === 3
            ? "visitors"
            : null,
        list: [],
        day: [],
        com: type === 1 ? "吨" : type === 2 ? "kw" : type === 3 ? "人" : null
      };
      this.get(
        "toiletData/reportByType",
        this.addDateRange(this.params, this.dateRange)
      ).then(res => {
        // if (res.data.rows.length === 0) {
        //   ElementUI.Notification({
        //     title: "数据不存在",
        //     message:
        //       "该时间段无" +
        //       (type === 1
        //         ? "水量"
        //         : type === 2
        //           ? "电量"
        //           : type === 3
        //             ? "人流量"
        //             : "该类型") +
        //       "数据。",
        //     type: "warning",
        //   });
        // }
        res.data.rows.map(e => {
          data.list.push(e.value);
          data.day.push(e.createTime.slice(0, e.createTime.length - 9));
        });
        this[data.id] = data;
      });
    },
    ChangeAlarm() {
      this.AlarmdialogVisible = false;
      this.markerAlarm[this.alarmData[1]].hide();
      let a = JSON.parse(localStorage.getItem("alarmList"));
      a.splice(this.alarmData[1], 1);
      localStorage.setItem("alarmList", JSON.stringify(a));
    },
    manageAlarm() {
      this.markerAlarm = JSON.parse(localStorage.getItem("alarmList"));
      let marklist = JSON.parse(localStorage.getItem("alarmList"));
      if (this.markerAlarm) {
        for (let i = 0; i < this.markerAlarm.length; i++) {
          this.markerAlarm[i] = new AMap.Marker({
            map: this.mapObj,
            icon: new AMap.Icon({
              size: new AMap.Size(36, 36),
              image: this.legend.img4, // 图标地址
              imageSize: new AMap.Size(36, 36)
            }),
            offset: new AMap.Pixel(-18, -18)
          });
          let h = this.$store.state.toiletinfo.filter(item => {
            return item.id == marklist[i].toiletId;
          });
          h.push(i);
          this.markerAlarm[i].setExtData(h);
          this.markerAlarm[i].setPosition({
            Q: h[0].lat,
            R: h[0].lng,
            lng: h[0].lng,
            lat: [0].lat
          });
          this.markerAlarm[i].setTitle(h[0].name + "告警");
          let that = this;
          this.markerAlarm[i].on("click", function(e) {
            that.alarmData = that.markerAlarm[i].getExtData();
            that
              .get("toiletInfo/view", { id: that.alarmData[0].id })
              .then(res => {
                that.alarmdatas = res.data.data;
              });
            that.AlarmdialogVisible = true;
          });
        }
      }
    },
    getToiletInfo() {
      this.loading = true;
      const styleObjectArr = [
        {
          url: this.legend.img1, // 图标地址
          size: new AMap.Size(36, 36), // 图标大小
          zIndex: 0,
          anchor: new AMap.Pixel(18, 18) // 图标显示位置偏移量，基准点为图标左上角
        },
        {
          url: this.legend.img2, // 图标地址
          size: new AMap.Size(36, 36), // 图标大小
          zIndex: 1,
          anchor: new AMap.Pixel(18, 18) // 图标显示位置偏移量，基准点为图标左上角
        },
        {
          url: this.legend.img5, // 图标地址
          size: new AMap.Size(36, 36), // 图标大小
          zIndex: 2,
          anchor: new AMap.Pixel(18, 18) // 图标显示位置偏移量，基准点为图标左上角
        }
      ];
      this.params = this.addDateRange(this.params, this.dateRange);
      this.get("toiletInfo/list", this.params).then(res => {
        let data = [];
        if (!this.toiletLists) {
          this.toiletLists = res.data.rows;
          this.toiletListData = res.data.rows;
        }
        // 清空之前的站点图层
        if (this.mass) this.mass.clear();
        // 统一数据格式，设置地图中心
        for (let i = 0; i < this.toiletLists.length; i++) {
          let item = this.toiletLists[i];
          // 改变中心点
          this.mapObj.setZoomAndCenter(13, [item.lng, item.lat]);
          if (item.toiletType === 1) {
            item.style = 0;
          } else if (item.toiletType === 2) {
            item.style = 1;
          } else {
            item.style = 2;
          }
          item.lnglat = [item.lng, item.lat];
          data.push(item);
        }
        // 设置海量点的层级和样式
        this.mass = new AMap.MassMarks(data, {
          opacity: 0.8,
          zIndex: 111,
          cursor: "pointer",
          style: styleObjectArr
        });
        // 设置鼠标经过点的显示按钮样式
        this.markerMove = new AMap.Marker({
          map: this.mapObj,
          icon: new AMap.Icon({
            size: new AMap.Size(36, 36),
            image: this.legend.img3, // 图标地址
            imageSize: new AMap.Size(36, 36)
          }),
          offset: new AMap.Pixel(-18, -18)
        });
        let self = this;
        this.mass.on("mouseover", function(e) {
          if (self.notChange) return;
          self.markerMove.setPosition(e.data.lnglat);
          self.markerMove.setTitle(e.data.name);
          if (!self.giveAnAlarm) {
            self.markerMove.show();
          }
          self.data = e.data;
          // 海量点点击事件
        });
        // 海量点点击事件
        this.markerMove.on("click", function() {
          self.name = self.data.name;
          self.params.toiletId = self.data.id;
          self.getEnergyList(1);
          self.getEnergyList(2);
          self.getEnergyList(3);
          self.$store.dispatch("gettolietyw", self.params.toiletId);
          self.centerDialogVisible = true;
        });

        // 设置海量点至地图
        this.mass.setMap(this.mapObj);

        // 自动定位到最合适的位置
        this.mapObj.setFitView();
        self.markerMove.hide();
        // 选择层级
        this.mapObj.setZoom(14);

        // 点击地图区域隐藏选中点，防止用户误解
        this.mapObj.on("click", function() {
          $("#code_core").hide("slow", function() {
            document.getElementById("map_canvas").style.marginRight = "0";
          });
          self.markerMove.hide();
        });
      });
    },
    enterNum(e) {
      if (e === 1) {
        this.titles = "智慧厕所（不含真空）";
        this.toiletLists = this.toiletListData.filter(function(item) {
          return item.toiletType === 1;
        });
      } else if (e === 2) {
        this.titles = "真空厕所";
        this.toiletLists = this.toiletListData.filter(function(item) {
          return item.toiletType === 2;
        });
      } else {
        this.titles = "传统厕所";
        this.toiletLists = this.toiletListData.filter(function(item) {
          return item.toiletType === 3;
        });
      }
      if (e === this.serchNum || this.serchNum == null) {
        this.searchShow = !this.searchShow;
      } else {
        this.searchShow = true;
      }
      this.serchNum = e;

      if (this.searchShow) {
        this.initAMap();
      }
    },
    searchOne(e) {
      this.toiletLists = this.toiletListData.filter(function(item) {
        return item.name === e.target.innerText;
      });
      if (this.searchShow) {
        this.initAMap();
      }
    },
    //websoket
    initSocket: function() {
      var timestamp = new Date().valueOf();
      if (typeof WebSocket === "undefined") {
        this.$message({
          message: "不支持websocket，无法接收告警信息。",
          type: "warning",
          duration: 3000
        });
      } else {
        // 实例化socket
        let path = global.webSocket + `${timestamp}`;
        this.socket = new WebSocket(path);
        this.socket.onopen = this.open;
        this.socket.onerror = this.error;
        this.socket.onmessage = this.getMessage;
        this.socket.onclose = this.close;
      }
    },
    open() {
      //连接成功调用send发送数据
    },
    error() {
      //连接失败重连
      this.initSocket();
    },
    getMessage(msg) {
      // 接收数据
      let arr = [];
      if (!localStorage.getItem("alarmList")) {
        localStorage.setItem("alarmList", JSON.stringify(arr));
      }
      if (JSON.parse(msg.data).status == 1) {
        this.alarmList = JSON.parse(localStorage.getItem("alarmList")).filter(
          item => {
            return item.toiletId != JSON.parse(msg.data).toiletId;
          }
        );
        this.alarmList.push(JSON.parse(msg.data));
        localStorage.setItem("alarmList", JSON.stringify(this.alarmList));
        this.manageAlarm();
      }
    },
    send(Data) {
      this.socket.send(Data);
    },
    close() {}
  },
  mounted() {
    this.$store.dispatch("gettoiletinfo", {});
    this.initSocket();
    this.initAMap();
    // this.manageAlarm();
  },
  destroyed() {
    this.close();
  },
  beforeUpdate() {
    const that = this;
    that.timerA = setInterval(function() {
      if (document.readyState === "complete") {
        that.loading = false;
        window.clearInterval(that.timerA);
      }
    }, 1000);
  }
};
</script>

<style scoped>
.amap-logo {
  display: none;
  opacity: 0 !important;
}

.amap-copyright {
  opacity: 0;
}

.mentten {
  height: 100%;
}

img {
  vertical-align: middle;
}

.thumbnail > img {
  display: block;
  max-width: 100%;
  height: auto;
}

.main-map {
  position: relative;
}

ul {
  padding: 0;
  margin: 0;
}

.search-map {
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
  width: 24%;
  height: 80%;
  padding: 1%;
}

.search-map img {
  width: 1.8vw;
  height: 1.8vw;
}

.search-text {
  font-size: 18px;
  color: #fff;
  box-shadow: rgb(4, 91, 146) 0 0 18px inset;
}

.search-map img:hover {
  width: 2vw;
  height: 2vw;
  transition: 0.6s;
}

.listOne {
  margin-top: 6px;
  cursor: pointer;
}

.listOne:hover {
  background-color: steelblue;
}
.textstyle {
  font-size: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/html/towMap.vue